module.exports = __webpack_public_path__ + "img/health.2850dbdf.svg";